import React from 'react'

import Typography from '@mui/material/Typography'
const SectionTitle = ({ title, ...rest }) => {
  return (
    <Typography
      component="h6"
      variant="h6"
      color="primary"
      sx={{ display: 'inline-flex', alignItems: 'center' }}
      {...rest}
    >
      {title}
    </Typography>
  )
}

export default SectionTitle
